/**
 * Cấu hình lời thoại MÁY TRẠM SẢN XUẤT — hiện chỉ có cảnh báo máy vò sắp dừng.
 *
 * Dùng chung giao diện với màn cấu hình máy trạm đơn hàng, chỉ khác tập case và
 * bảng tra placeholder (màn này chỉ có {ma_may} + {thoi_gian_con_lai}).
 */

import { createFileRoute } from '@tanstack/react-router'

import { StationVoiceSettingsView } from '@/components/station-voice/station-voice-settings-view'
import { isProductionStationCase } from '@/lib/station-voice-cases'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/production-station-voice',
)({ component: ProductionStationVoicePage })

function ProductionStationVoicePage() {
    return (
        <StationVoiceSettingsView
            title={m.station_voice_production_title()}
            includeCase={isProductionStationCase}
        />
    )
}
